import { EDIT_CARD, MODERATE_CARD, VIEW_CARD } from '@/common/rights.js';
import { boundApiRequest } from '@/restapi/restapi.base.js';

const doRequest = boundApiRequest('/api/user/');



/**
 * Авторизоваться на сайте
 */
export async function login(body) {
    const { result } = await doRequest('login', body, {
        messages: false,
    });
    return result;
}

/**
 * Уничтожить сессию пользователя
 */
export async function logout() {
    const { result } = await doRequest('logout', {});
    return result;
}

/**
 * Проверить сессию пользователя
 */
export async function checkSession() {
    const { result } = await doRequest('check/session', {}, {
        messages: false,
    });
    return result;
}

/**
 * Зарегистрироваться на сайте
 */
export async function signup(body) {
    const { result } = await doRequest('signup', body, {
        messages: false,
    });
    return result;
}

/**
 * Подтвердить регистрацию
 */
export async function signupConfirm(body) {
    const { result } = await doRequest('signup/confirm', body, {
        messages: false,
    });
    return result;
}

/**
 * Запросить восстановление пароля
 */
export async function restore(body) {
    const { result } = await doRequest('restore', body, {
        messages: false,
    });
    return result;
}

/**
 * Подтвердить восстановление пароля
 */
export async function restoreConfirm(body) {
    const { result } = await doRequest('restore/confirm', body, {
        messages: false,
    });
    return result;
}

/**
 * Проверить существование email
 */
export async function checkEmail(body) {
    const { result } = await doRequest('check/email', body, {
        messages: false,
    });
    return result;
}

/**
 * Обновить информацию пользователя
 */
export async function profileUpdate(body) {
    const { result } = await doRequest('profile/update', body, {
        blocking: true,
        messages: false,
    });
    return result;
}

export async function processingAgreement(processingAgreed) {
    await doRequest('processingAgreement', { processingAgreed });
}


/**
 * Изменить пароль пользователя
 */
export async function passwordChange(body) {
    const { result } = await doRequest('password/change', body, {
        messages: false,
    });
    return result;
}

export async function findUser(query = '', rights = [ VIEW_CARD ]) {
    const { result } = await doRequest('find', {
        rights,
        limit: 12,
        query,
    });
    return result;
}

export async function findUserAmongModerAndEditor(query = '') {
    return await findUser(query, [ MODERATE_CARD, EDIT_CARD ]);
}

export async function loadUser(id) {
    const { result } = await doRequest('load', { id });
    return result;
}
